var themeOptions = function () {
  return {
    components: {
      MuiAvatarGroup: {
        styleOverrides: {
          root: {
            flexDirection: 'row'
          }
        }
      }
    }
  };
};
export default themeOptions;